/**
 * A global namespace for `submit` event.
 */
const submitEvent = 'submit';
export default submitEvent;
